import { useApiQuery } from '../../hooks/use-api';
import { Session } from '../../types/api';

export function useSessionDetail(sessionId: string) {
  const endpoint = `/sessions/${sessionId}`;
  return useApiQuery<Session>(['sessions', sessionId], endpoint, { enabled: !!sessionId });
}